import { LIFE_ACCIDENTS_BUSINESS_LINE, HEALTH_HEALTH_PRODUCT } from "../constants/policyType";
import GeneralServices from "./GeneralServices";
import { CatchErrorType } from "./dto/response/CommonResponse.dto";
import {
  IGetAllowedProductsByRoleRequest,
  IGetAllowedProductsByRoleOK,
  IResponseError
} from "./ProductServices.dto";

class ProductServices {

  getDynamicProducts = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader === false ? false : true,
        endpoint: `products/dinamicProducts/${args.mediator_id} `
      });
      return response.data;
    } catch (err) {
      throw err
    }
  };

  getProductPermission = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader === false ? false : true,
        endpoint: `products/permission?product_id=${args.product_id}&mediator_id=${args.mediator_id}`
      });
      return response.data.isAllowed;
    } catch (err) {
      return false;
    }
  };

  getProductLinks = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader === false ? false : true,
        endpoint: `products/productLinks`
      });
      return response.data;
    } catch (err) {
      return [] ;
    }
  }

  getPolicyTypes = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader === false ? false : true,
        endpoint: `products/getPolicyTypes`
      });
      return response.data;
    } catch (err) {
      return [] ;
    }
  }

  getProductsByAreaName = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader === false ? false : true,
        endpoint: `products/getProductsByAreaName`
      });
      return response.data;
    } catch (err) {
      return {};
    }
  }

  checkProductArea = (area: string, internalName: string,  productsByAreaName: any) => {
    if(Object.keys(productsByAreaName).length===0 || !productsByAreaName[area]){
      return false
    }else{
     return productsByAreaName[area].includes(internalName);
    }
  }

  isAccidentProduct = (product: any) => {
    return product.ln_linea_negocio === LIFE_ACCIDENTS_BUSINESS_LINE
  }

  isHealthHealthProduct = (internalName: string): boolean => {
    return Object.values(HEALTH_HEALTH_PRODUCT).indexOf(internalName) !== -1;
  };

  getAllProducts = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader === false ? false : true,
        endpoint: `products/getAllProducts`
      });
      return response.data;
    } catch (err) {
      return {};
    }
  }

  getActiveProducts = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader === false ? false : true,
        endpoint: `products/getActiveProducts`
      });
      return response.data;
    } catch (err) {
      return {};
    }
  }

  getInactiveProducts = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader === false ? false : true,
        endpoint: `products/getInactiveProducts`
      });
      return response.data;
    } catch (err) {
      return {};
    }
  }

  getProductsByName = async (args: any) => {
    try {
      const res = await GeneralServices.get({
        loader: args.loader === false ? false : true,
        setLoading: args.setLoading,
        endpoint: `products/getProductsByName`
      });
     
      return res.data;
    } catch (err) {
      return {};
    }
  };

  getProductCapitals = async (args: any) => {
    try {
      const res = await GeneralServices.get({
        loader: args.loader === false ? false : true,
        setLoading: args.setLoading,
        endpoint: `products/getProductCapitals?productId=${args.productId}`
      });
     
      return res.data;

    } catch (err) {
      return null;
    }
  };

  getAllowedProductsByRole = async ({
    loader,
    setLoading,
    mediatorId
  }: IGetAllowedProductsByRoleRequest): Promise<IGetAllowedProductsByRoleOK | IResponseError> => {
    try {
      const res = await GeneralServices.get({
        loader,
        setLoading,
        endpoint: `products/getAllowedProductsByRole?mediator_id=${mediatorId.toLocaleUpperCase()}`
      });

      return {
        ok: true,
        data: res.data,
      }
    } catch (err) {
      const typedError = err as CatchErrorType;
      const errorMsg = typedError.data && typedError.data.message;

      return {
        ok: false,
        message: typeof errorMsg === "string" ? errorMsg :  "Se ha producido un error en la recuperación de los permisos.",
      };
    }
  }

}

export default new ProductServices();
